import { useTenantImages } from "@b2bportal/core-themes";
import {
  type PlatformComponentProps,
  ProductType,
} from "@b2bportal/core-types";
import type { HomesReservation } from "@b2bportal/homes-api";
import { TripsCard } from "@tenant/trips";
import { useHomesReservationCard } from "./useHomesReservationCard";
import { TripsReservationStatusPill } from "@/components";

export interface HomesReservationCardComponentProps
  extends PlatformComponentProps {
  reservation: HomesReservation;
  selectItinerary: () => void;
}

export const HomesReservationCard = (
  props: HomesReservationCardComponentProps
) => {
  const images = useTenantImages();
  const { className, children, reservation, selectItinerary } = props;
  const { text, isCancelled } = useHomesReservationCard(reservation);

  const dateDisplay = (
    <span style={isCancelled ? { textDecoration: "line-through" } : undefined}>
      {text.dates}
    </span>
  );

  return (
    <TripsCard
      className={className}
      title={text.title}
      onClick={selectItinerary}
      confirmationCode={reservation.id.value}
      description={text.location}
      date={dateDisplay}
      image={reservation.listing.coverImage || images.hotelPlaceholder}
      status={
        <TripsReservationStatusPill
          variant={ProductType.HOMES}
          status={reservation.status.ReservationStatus}
        />
      }
    >
      {children}
    </TripsCard>
  );
};
